/* eslint-disable @typescript-eslint/no-namespace */
export namespace Meta {
    export enum ConfiguredStatus {
        Active = 'ACTIVE',
        Paused = 'PAUSED',
        Deleted = 'DELETED',
        Archived = 'ARCHIVED',
    }

    export enum EffectiveStatus {
        Active = 'ACTIVE',
        Paused = 'PAUSED',
        Deleted = 'DELETED',
        PendingReview = 'PENDING_REVIEW',
        Disapproved = 'DISAPPROVED',
        PreApproved = 'PREAPPROVED',
        PendingBillingInfo = 'PENDING_BILLING_INFO',
        CampaignPaused = 'CAMPAIGN_PAUSED',
        Archived = 'ARCHIVED',
        AdsetPaused = 'ADSET_PAUSED',
        InProgress = 'IN_PROCESS',
        WithIssues = 'WITH_ISSUES',
    }

    export type Campaign = {
        id: string;
        name: string;
        startDate: string;
        endDate: string;
        configuredStatus: ConfiguredStatus;
        effectiveStatus: EffectiveStatus;
        createdDate: string;
    };

    export type AdGroup = {
        id: string;
        name: string;
        configuredStatus: ConfiguredStatus;
        effectiveStatus: EffectiveStatus;
        dailyBudgetMicro?: number;
        createdDate: string;
    };

    export type Ad = {
        id: string;
        name: string;
        adSetId: string;
        configuredStatus: ConfiguredStatus;
        effectiveStatus: EffectiveStatus;
        createdDate: string;
    };
}
